// Az ajánlatkérő űrlap opciói. A beküldés már valódi backend API-ra megy (POST /api/leads),
// a korábbi localStorage-os mock mentés megszűnt.

export const TERVEZESI_FELADATOK = [
  "Lakóház",
  "Társasház",
  "Középület",
  "Belsőépítészet",
  "Felújítás / bővítés",
  "Egyéb",
];

export const MERETEK = [
  "100m²>",
  "100–200m²",
  "200–300m²",
  "300–500m²",
  "500m²<",
];
